export default __webpack_public_path__ + "static/media/plain-sticker-oi.c7dc369f.png";